
(function() {
    // Add custom code below this line

    function mountSliders() {
        document.addEventListener('DOMContentLoaded', function () {
            const cSliderElements = document.querySelectorAll('swiper-container.collection__slider');

            cSliderElements.forEach((sliderEl) => {
                const sliderId = sliderEl.getAttribute('id');
                
                const prevButton = document.querySelector(`.swiper-button-prev[data-navigation-prev="navigation-prev-${sliderId}"]`);
                const nextButton = document.querySelector(`.swiper-button-next[data-navigation-next="navigation-next-${sliderId}"]`);

                const params = {
                    slidesPerView: 4,
                    pagination: {
                        renderProgressbar: function (progressbarFillClass) {
                            return '<span class="' + progressbarFillClass + '"></span>';
                        },
                        enabled: true,
                        type: 'progressbar',
                    },
                    spaceBetween: 20,
                    navigation: {
                        prevEl: prevButton,
                        nextEl: nextButton,
                    },
                    breakpoints: {
                        0: {
                            slidesPerView: 2,
                            navigation: {
                                enabled: false,
                            },
                        },
                        420: {
                            slidesPerView: 2,
                            navigation: {
                                enabled: false,
                            },
                        },
                        550: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                            navigation: {
                                enabled: false,
                            },
                        },
                        640: {
                            slidesPerView: 3,
                        },
                        768: {
                            slidesPerView: 3,
                            navigation: {
                                enabled: true,
                            },
                        },
                        1024: {
                            slidesPerView: 4,
                        },
                    },
                    injectStyles: [
                        `
                        .swiper-button-next,
                        .swiper-button-prev {
                            background-position: center;
                            background-size: 28px;
                            background-repeat: no-repeat;
                            padding: 8px 16px;
                            border-radius: 100%;
                        }

                        .swiper-button-next svg,
                        .swiper-button-prev svg {
                            display: none;
                        }

                        .swiper-button-prev {
                            background-image: url("https://cdn.shopify.com/s/files/1/0420/8535/1573/files/icon-arrow-left.svg?v=1746386799");
                        }

                        .swiper-button-next {
                            background-image: url("https://cdn.shopify.com/s/files/1/0420/8535/1573/files/icon-arrow-right.svg?v=1746386799");
                        }

                        .swiper-button-next::after,
                        .swiper-button-prev::after {
                            content: "";
                        }
                        
                        .swiper-pagination {
                            position: static;
                            margin-top: 24px;
                        }

                        .swiper-pagination-bullet{
                            width: 10px;
                            height: 10px;
                            background-color: #17CEB0;
                            opacity: 1;
                        }

                        .swiper-pagination-bullet:not(.swiper-pagination-bullet-active) {
                            background-color: #B2FFE7;
                            opacity: 1;
                        }

                        .swiper-pagination-progressbar-fill {
                            background: rgb(var(--color-foreground))!important;
                        }
                    `,
                    ],
                }

                Object.assign(sliderEl, params);
                sliderEl.initialize();
            });
        });
    }

    mountSliders();

    if (Shopify.designMode || Shopify.visualPreviewMode) {
        document.addEventListener('shopify:section:load', mountSliders());
        document.addEventListener('shopify:section:reorder', mountSliders());
        document.addEventListener('shopify:block:select', mountSliders());
    }


    // Collection Tabs
    class FeaturedCollectionsTab extends HTMLElement {
        connectedCallback() {
            this.items = Array.from(this.querySelectorAll('.featured-collections-carousel__item'));
            this.items.forEach(item => item.classList.remove('active'));

            const navs = document.querySelectorAll(`[data-for="controlls-${this.id}"]`);

            navs.forEach(nav => {
                const buttons = nav.querySelectorAll('button[data-index]');
                const select = nav.querySelector('select');

                buttons.forEach(button =>
                    button.addEventListener('click', () => {
                        const index = +button.dataset.index;
                        this.showTab(index, nav);
                    })
                );

                if (select) {
                    ['input','change'].forEach(evt =>
                        select.addEventListener(evt, () => {
                        this.showTab(+select.value, nav);
                        })
                    );
                }
            });

            this.showTab(0); // inicial
        }

        showTab(index, navContainer = null) {
            this.items.forEach((item, i) => {
                item.classList.toggle('active', i === index);
                item.style.opacity = i === index ? '1' : '0';
                item.style.transition = 'all 0.3s ease';
            });

            if (navContainer) {
                const buttons = navContainer.querySelectorAll('button[data-index]');
                const select  = navContainer.querySelector('select');

                if (select) {
                    // 1) actualiza el valor
                    select.value = index;
                    // 2) dispara 'change' para que <x-popover-select> se sincronice visualmente
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                    // (no hace falta 'input' aquí a menos que quieras que otro listener reaccione también)
                }

                buttons.forEach((btn, i) => {
                    btn.classList.toggle('is-active', i === index);
                    btn.disabled = i === index;
                });
            }
        }
    }

    customElements.define('featured-collections-tab', FeaturedCollectionsTab);


    // Product accordions hide
    document.querySelectorAll('.product__info-container .product__accordion').forEach(accordion => {
        const content = accordion.querySelector('.accordion__content');
        if (!content || !content.textContent.trim()) {
            accordion.style.display = 'none';
        }
    });

    // Custom select popover

    class XPopoverSelect extends HTMLElement{
    connectedCallback(){
        // Select fuente (nativo)
        const selectId = this.dataset.for;
        const select = document.getElementById(selectId);
        if(!select){ console.warn('[x-popover-select] select no encontrado:', selectId); return; }

        // Crear estructura
        this.classList.add('xps');
        this.innerHTML = `
        <button type="button" class="xps__button" aria-haspopup="listbox" aria-expanded="false">
            <span class="xps__label">${this.dataset.label || ''}</span>
            <span class="xps__value"></span>
            <span class="xps__caret" aria-hidden="true"></span>
            <span class="svg-wrapper">
                <svg class="icon icon-caret" xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                <path d="M1 1L5 5L9 1" stroke="#932F31" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
        </button>
        <div class="xps__menu" role="listbox" hidden></div>
        `;

        this._button = this.querySelector('.xps__button');
        this._menu   = this.querySelector('.xps__menu');
        this._value  = this.querySelector('.xps__value');

        // Construir opciones desde el select
        this._options = [];
        [...select.options].forEach((opt, idx) => {
        // Separadores opcionales por texto (ejemplo "—" o similares)
        const li = document.createElement('div'); li.className = 'xps__item';

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'xps__option';
        btn.role = 'option';
        btn.dataset.value = opt.value;
        btn.textContent = opt.text;
        if(opt.selected) btn.setAttribute('aria-selected','true');

        btn.addEventListener('click', () => this._choose(opt.value, true));
        li.appendChild(btn);
        this._menu.appendChild(li);

        // Ejemplo de regla visual entre grupos (opcional):
        const needsRule = /lo más nuevo|más vendidos|a - z|z - a|menor a mayor|mayor a menor|antiguo\(a\) a reciente|reciente a antiguo\(a\)/i.test(opt.text) && idx !== select.options.length-1;
        /* if(needsRule) {
            const hr = document.createElement('hr');
            hr.className = 'xps__rule';
            this._menu.appendChild(hr);
        } */

        this._options.push(btn);
        });

        // Estado inicial
        this._syncFromSelect(select);

        // Eventos abrir/cerrar
        this._button.addEventListener('click', () => this._toggle());
        document.addEventListener('click', (e)=>{
            if (!this.contains(e.target)) this._close({ returnFocus: false });
        });

        // Teclado
        this._button.addEventListener('keydown', (e)=> this._onButtonKeydown(e));
        this._menu.addEventListener('keydown', (e)=> this._onMenuKeydown(e));

        // Si el select cambia por otros medios, sincronizamos
        select.addEventListener('change', ()=> this._syncFromSelect(select));
    }

    _toggle(){
        const isOpen = !this._menu.hasAttribute('hidden');
        isOpen ? this._close({ returnFocus: false }) : this._open();
    }
    _open(){
        this._menu.removeAttribute('hidden');
        this._button.setAttribute('aria-expanded','true');
        const current = this._options.find(o => o.getAttribute('aria-selected') === 'true') || this._options[0];
        current.focus();
    }
    // options: { returnFocus: boolean }
    _close(opts = { returnFocus: false }){
        if (this._menu.hasAttribute('hidden')) return;
        this._menu.setAttribute('hidden','');
        this._button.setAttribute('aria-expanded','false');
        if (opts.returnFocus) {
            this._button.focus({ preventScroll: true }); // 👈 sin scroll
        }
    }

    _choose(value){
        const select = document.getElementById(this.dataset.for);
        if (!select) return;

        // Actualiza el <select> real y dispara AJAX (tu FacetFiltersForm escucha 'input')
        select.value = value;
        select.dispatchEvent(new Event('input', { bubbles: true }));

        // UI
        this._options.forEach(o => o.setAttribute('aria-selected', String(o.dataset.value === value)));
        this._value.textContent = select.selectedOptions[0]?.text || '';

        // Cerrar sin devolver foco (si vino por teclado, ya lo hace _onMenuKeydown con Escape)
        this._close({ returnFocus: false });
    }

    _syncFromSelect(select){
        const val = select.value;
        this._value.textContent = select.selectedOptions[0]?.text || '';
        this._options.forEach(o => o.setAttribute('aria-selected', String(o.dataset.value === val)));
    }

    _onButtonKeydown(e){
    switch(e.key){
        case 'ArrowDown':
        case 'Enter':
        case ' ':
        e.preventDefault(); this._open(); break;
    }
    }

    _onMenuKeydown(e){
        const items = this._options;
        const idx = items.indexOf(document.activeElement);

        if (e.key === 'Escape'){
            e.preventDefault();
            this._close({ returnFocus: true }); // 👈 devolver foco sin mover scroll
            return;
        }
        if (e.key === 'ArrowDown'){
            e.preventDefault(); (items[idx+1] || items[0]).focus();
        } else if (e.key === 'ArrowUp'){
            e.preventDefault(); (items[idx-1] || items[items.length-1]).focus();
        } else if (e.key === 'Enter' || e.key === ' '){
            e.preventDefault();
            const el = document.activeElement;
            if (el && el.dataset?.value) this._choose(el.dataset.value); // _choose cierra
        }
    }
    }
    customElements.define('x-popover-select', XPopoverSelect);



    // ^^ Keep your scripts inside this IIFE function call to 
    // avoid leaking your variables into the global scope.
})();